<template>
    <v-dialog v-if="opened" v-model="opened" max-width="600" persistent>
      <v-form ref="formBooking" v-model="valid" @submit.prevent="save()">
        <v-card :loading="loadingData" :disabled="loadingData">
          <v-card-title class="h-100">
            <div class="d-flex align-items-center">
              {{ !id ? " Tambah" : "Ubah" }}
              <v-btn icon @click="close()" class="ml-auto">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </div>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row justify="center" no-gutters>
                <v-col cols="12" md="10">
                  <v-autocomplete
                    label="Member"
                    required
                    dense
                    outlined
                    v-model="data.member_id"
                    :items="listMember"
                    item-text="name"
                    item-value="id"
                    :rules="[
                      v => !!v || 'Member harus diisi',
                    ]"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" md="10">
                  <v-checkbox
                    v-model="data.is_present"
                    label="Kehadiran"
                    dense
                    class="mt-3"
                  ></v-checkbox>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
  
          <v-card-actions>
            <v-row no-gutters>
              <v-col cols="12" class="d-flex justify-end">
                <v-btn
                  depressed
                  class="ma-1"
                  :disabled="loading"
                  @click="close()"
                >
                  <v-icon small left>mdi-close</v-icon>
                  Tutup
                </v-btn>
                <v-btn
                  type="submit"
                  color="success"
                  depressed
                  class="ma-1"
                  :loading="loading"
                  :disabled="loading"
                  @click.prevent="save()"
                >
                  <v-icon small left>mdi-content-save</v-icon>
                  Simpan
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </template>
  
  <script>
  import ApiService from "@/core/services/api.service";
  
  let timeout = null;
  export default {
    data() {
      return {
        action: "create",
        id: null,
        opened: false,
        loading: false,
        loadingData: false,
        valid: true,
        listZone: [],
        isLoadingZone: false,
        listMember: [],
        search: "",
        data: {
          member_id: null,
          is_present: false,
          class_schedule_id: this.classScheduleId || null,
        }
      };
    },
    props: {
      success: {
        type: Function,
        default: function() {}
      },
      classScheduleId: {
        type: String,
        default: null
      }
    },
    async mounted() {
      this.getMembers();
    },
    methods: {
      async getMembers() {
        const { data } = await ApiService.get("user/list?role_slug=member");
        this.listMember = data;
      },
      open(userId, id) {
        if (!userId) {
          return;
        }
        this.data.user_id = userId;
        this.opened = true;
        setTimeout(() => {
          this.$refs.formBooking.reset();
          if (id) {
            this.getData(id);
          }
        }, 1);
      },
      async getData(id) {
        this.loadingData = true;
        ApiService.get("class-booking?id=" + id)
          .then(({ data }) => {
            this.data = {
              member_id: data.member_id,
              is_present: data.is_present,
              class_schedule_id: data.class_schedule_id,
            };
            this.id = id;
            this.loadingData = false;
          })
          .catch(({ response }) => {
            if (response.data) {
              this.handleError(response.data);
            }
            this.loadingData = false;
          });
      },
      async save() {
        this.$refs.formBooking.validate();
        if (this.valid) {
          this.loading = true;
          const action = !this.id ? "post" : "update";
          let url = "class-booking";
          if (this.id) {
            url = url + "?id=" + this.id;
          }
          ApiService[action](url, this.data)
            .then(({ data }) => {
              if (data.id) {
                this.loading = false;
                this.success(data);
                this.$swal.fire({
                  icon: "success",
                  title: "Berhasil",
                  text: "Data berhasil disimpan",
                  showConfirmButton: false,
                  timer: 3000
                });
                this.close();
              }
            })
            .catch(({ response }) => {
              if (response.data) {
                this.handleError(response.data);
              }
  
              this.loading = false;
            });
        }
      },
      handleError(data) {
        if (data.error) {
          this.$swal.fire({
            icon: "warning",
            title: "Terjadi kesalahan",
            text: data.error,
            showConfirmButton: true,
            timer: 5000
          });
        }
      },
      close() {
        this.opened = false;
        this.id = null;
        this.data.user_id = null;
        (this.listZone = []), (this.isLoadingZone = false);
        this.search = "";
        this.$refs.formBooking.reset();
      },
    },
    watch: {
      search(val) {
        if (!val) {
          return;
        }
        clearTimeout(timeout);
  
        timeout = setTimeout(async () => {
        }, 200);
      }
    }
  };
  </script>
  